import './styles.scss';

import "jquery-ui/ui/disable-selection";
import "jquery-ui/ui/widget";
import './_typeit.js';

function randrange(min, max) {
  return Math.floor(Math.random() * (max - min) + min);
}

function scrolldown(timeout, loop) {
  setTimeout(function() {
    if (!document.querySelector('.ui-chatbox-log')) return
    var box = $('.ui-chatbox-log');
    box.scrollTop(box.get(0).scrollHeight);
    loop--;
    if (loop > 0) {
      scrolldown(timeout, loop);
    }
  }, timeout);
}
var _vp;
var _oldVP;

var fixViewportOn = (function() {
  return;
  $('body')
    .addClass('fixfixed')
    .addClass('fixviewport');
  _vp = $("meta[name=viewport]");
  _oldVP = _vp.attr('content');
  _vp.attr('content', 'height=device-height, ' +
    'initial-scale=1.0, user-scalable=0');
});

var fixViewportOff = (function() {
  return;
  $('body')
    .removeClass('fixfixed')
    .removeClass('fixviewport');
  _vp.attr('content', self._oldVP);
});


function type_it2(element, fragments, callback_func) {
  $("#ui-chatbox-outer")
    .addClass('ui-chatbox-typing')
    .removeClass('ui-chatbox-cts');
  var box = $('.ui-chatbox-log');
  box.scrollTop(box.get(0).scrollHeight);

  var e = $(element).typeIt({
    cursor: true,
    cursorSpeed: 0,
    lifeLike: true,
    autoStart: true,
    callback: function() {
      //console.log('got here');
      // detach the typeIt cursor.
      $('.ti-cursor').remove();

      // allow user input
      window.setTimeout(function () {
        $("#ui-chatbox-outer")
          .removeClass('ui-chatbox-typing')
          .addClass('ui-chatbox-cts') }, 0);

      //$('.ui-chatbox-input:visible').focus()
      if (callback_func !== undefined) {
        callback_func();
      }
      box.scrollTop(box.get(0).scrollHeight);
    }
  });

  var lines = 0;
  fragments.forEach(function(elem) {
    lines = lines + elem.length / 50;
    /* split at setence breaks */
    elem = elem.replace(/([.!?]+)/g, "$1@@@") + ' ';
    elem.split(/@@@/).forEach(function(sent) {
      var ratio = 1.0;
      /* speed up if it ends in an exclamation point */
      if (elem.indexOf('!') !== -1) {
        ratio = 0.7;
      }
      e = e.tiSettings({
        speed: randrange(60, 75) * ratio * window.tMultiplier,
      }).tiType(sent).tiPause(randrange(350, 450));
    });

  });
  scrolldown(64 * 30, lines * 2);
}



function init() {
  return $.widget("ui.chatbox", {
    options: {
      id: null,
      //id for the DOM element
      title: null,
      // title of the chatbox
      user: null,
      // can be anything associated with this chatbox
      messageSent: function(id, user, msg) {
        // override this
        this.boxManager.addMsg(user.first_name, msg);
        scrolldown(30, 1);
      },
      boxClosed: function(id) {
        $('.ui-chatbox').remove();
        fixViewportOff();
      },
      // called when the close icon is clicked
      boxManager: {
        // thanks to the widget factory facility
        // similar to http://alexsexton.com/?p=51
        init: function(elem) {
          this.elem = elem;
        },
        addMsg: function(peer, msg, callback) {
          var self = this;
          var msgspan = $('<span/>').appendTo(
            $('<div/>').appendTo($('.ui-chatbox-log'))
            .addClass((function() {
              switch (true) {
                case peer.match(/^wrkstn/) !== null:
                  return "ui-chatbox-message-remote";
                  break;
                case peer == 'notice':
                  return "ui-chatbox-message-notice";
                  break;
                case peer == 'error':
                  return "ui-chatbox-message-error";
                  break;
                default:
                  return 'ui-chatbox-message-local';
                  break;
              }
            }())
          ).append($('<span/>')
            .addClass('ui-chatbox-message-peername')
            .text(peer + "> "))
          );

          if (peer.match(/wrkstn/) !== null) {
            type_it2(msgspan, msg, callback);
          } else {
            msgspan.text(msg);
          }
          self.elem.uiChatboxInputBox = $('.ui-chatbox-input');
          self._scrollToBottom();
          if (!self.elem.uiChatboxInputBox.is(":visible")) {
            self.highlightBox();
          }
          if (self.elem.uiChatboxEditable.is(":visible")) {
            //$('.ui-chatbox').focus();
          } else {
            //$('.ui-chatbox-titlebar').focus();
          }
          scrolldown(50, 5);

        },
        highlightBox: function() {
          var self = this;
          $('.ui-chatbox-titlebar')
            .css("background-color", "yellow");
        },
        toggleBox: function() {
          this.elem.uiChatbox.toggle();
        },
        _scrollToBottom: function() {
          var box = $(".ui-chatbox-log");
          //box.scrollTop(box.get(0).scrollHeight);
        }
      }
    },
    toggleContent: function(event) {
      this.uiChatboxContent.toggle();
      if (this.uiChatboxContent.is(":visible")) {
        //this.uiChatboxEditable.focus();
        this.uiChatbox.addClass('ui-chatbox-open');
       fixViewportOn();
      } else {
        //this.uiChatboxTitlebar.focus();
        this.uiChatbox.removeClass('ui-chatbox-open');
       fixViewportOff();
      }

    },
    widget: function() {
      return this.uiChatbox;
    },
    _create: function() {
      fixViewportOn();
      var self = this,
        options = self.options,
        title = options.title || "No Title",
        // chatbox
        uiChatbox = (self.uiChatbox = $('<div></div>'))
        .appendTo(document.body)
        .addClass('ui-widget ui-corner-top ui-chatbox')
        .addClass('ui-chatbox-open')
        .addClass('fix-viewport')
        .attr('outline', 0)
        .attr('id', "ui-chatbox-outer")
        .focusin(function() {
          // ui-state-highlight is not really helpful here
          //self.uiChatbox.removeClass('ui-state-highlight');
          self.uiChatboxTitlebar.addClass('ui-state-focus');
          $('body').addClass('fixfixed noscroll');
          self.uiChatbox.addClass('ui-state-focus');
        })
        .focusout(function() {
          //alert('focus out');
          self.uiChatboxTitlebar.removeClass('ui-state-focus');
          $('body').removeClass('fixfixed noscroll');
          self.uiChatbox.removeClass('ui-state-focus');
        }),
        // titlebar
        uiChatboxTitlebar = (self.uiChatboxTitlebar = $('<div></div>'))
        .addClass('ui-widget-header ' +
          'ui-corner-top ui-chatbox-titlebar ui-dialog-header '
        )
        .click(function(event) {
          //self.uiChatbox.removeClass('ui-state-highlight');
          //self.toggleContent(event);
          if (self.uiChatboxEditable.is(":visible")) {
            //self.uiChatboxEditable.focus();
          } else {
            self.toggleContent(event);
          }
        }).appendTo(uiChatbox),

        uiChatboxTitle = (self.uiChatboxTitle = $('<span></span>'))
        .html(title)
        .addClass('ui-chatbox-title')
        .appendTo(uiChatboxTitlebar),
        uiChatboxTitlebarClose = (
          self.uiChatboxTitlebarClose = $('<a href="#"></a>'))
        .addClass('ui-corner-all ' +
          'ui-chatbox-icon '
        )
        .attr('role', 'button')
        .hover(function() {
          uiChatboxTitlebarClose.addClass('ui-state-hover'); },
          function() {
            uiChatboxTitlebarClose.removeClass('ui-state-hover'); })
        .click(function(event) {
          uiChatbox.hide();
          self.options.boxClosed(self.options.id);
          return false;
        })
        .appendTo(uiChatboxTitlebar),
        uiChatboxTitlebarCloseText = $('<span></span>')
        .addClass('ui-chatbox-close')
        .appendTo(uiChatboxTitlebarClose),
        uiChatboxTitlebarMinimize = (
          self.uiChatboxTitlebarMinimize = $('<a href="#"></a>'))
        .addClass('ui-corner-all ' +
          'ui-chatbox-icon'
        ).attr('role', 'button')
        .hover(function() {
          uiChatboxTitlebarMinimize
            .addClass('ui-state-hover'); }, function() {
              uiChatboxTitlebarMinimize
                .removeClass('ui-state-hover');
            }).click(function(event) {
              self.toggleContent(event);
              return false;
            }).appendTo(uiChatboxTitlebar),
        uiChatboxTitlebarMinimizeText = $('<span></span>')
        .addClass('ui-chatbox-minimize')
        .appendTo(uiChatboxTitlebarMinimize),
        // content
        uiChatboxSessionId = $('<span></span>')
        .addClass('ui-chatbox-sessionid')
        .appendTo(uiChatboxTitlebar),
        uiChatboxContent = (self.uiChatboxContent = $('<div></div>'))
        .addClass('ui-widget-content ui-chatbox-content '
        )
        .appendTo(uiChatbox),
        uiChatboxLog = (self.uiChatboxLog = self.element)
        .addClass('ui-widget-content ui-chatbox-log ')
        .addClass('allow-scrolling')
        .appendTo(uiChatboxContent),
        uiChatboxInputBox = (self.uiChatboxInputBox = $('<div></div>'))
        .addClass('ui-widget-content')
        .addClass('ui-chatbox-input-box')
        .appendTo(uiChatboxContent),
        uiChatboxStatusBar = (self.uiChatboxStatusBar = $('<div></div>'))
        .addClass('ui-widget-content ui-chatbox-status-bar')
        .appendTo(uiChatboxInputBox),
        uiChatboxInputWrapper = (self.uiChatboxInputWrapper = $('<div></div>'))
        .addClass('ui-widget-content')
        .addClass('ui-chatbox-input-wrapper')
        .appendTo(uiChatboxInputBox),
        uiChatboxEditable = (self.uiChatboxEditable = $('<div></div>'))
        .attr('contenteditable', 'true')
        .addClass('ui-chatbox-input')
        .appendTo(uiChatboxInputWrapper)
        .keydown(function(event) {
          if (event.keyCode && event.keyCode === 13) { // ENTER
            if ($('#ui-chatbox-outer').hasClass('ui-chatbox-cts') &&
              $('#ui-chatbox-outer').hasClass('ui-chatbox-connected')) {
              var msg = $.trim($(this).text());
              if (msg.length > 0) {
                $("#ui-chatbox-outer").removeClass('ui-chatbox-cts');
                self.options.messageSent(
                  self.options.id, self.options.user, msg);
              }
              $(this).text('');
            } else {
              uiChatboxInputWrapper.animate(
                { 'background': "#8b0000", },
                { duration: 100, queue: false,
                  always: function() {
                    uiChatboxInputWrapper.animate(
                      { 'background-color': "#151515", },
                      { duration: 100, queue: true, });
                  }
                }
              );
            }
            event.preventDefault();
          }
        }).focusin(function() {
          var box = $(this).parent().parent().prev();

        })
        .focusout(function() {
          uiChatbox.removeClass('ui-state-fix-viewport'); });

      // disable selection
      uiChatboxTitlebar.find('*').addClass(
        uiChatboxTitlebar).disableSelection();

      // switch focus to input box when whatever clicked
      uiChatboxContent.children().click(function() {
        // click on any children, set focus on input box
        var editable = $('.ui-chatbox-input');
        if (editable.is(':visible')) {
          editable.focus();
        }
      });

      self._setWidth(self.options.width);
      self._position(self.options.offset);

      self.options.boxManager.init(self);

      if (!self.options.hidden) {
        uiChatbox.show();
        setTimeout(function () {
          uiChatboxEditable.focus();
        }, 250);
      }
    },
    _setOption: function(option, value) {
      if (value !== null) {
        switch (option) {
          case "hidden":
            if (value) {
              this.uiChatbox.hide();
            } else {
              this.uiChatbox.show();
            }
            break;
          case "offset":
            this._position(value);
            break;
          case "width":
            this._setWidth(value);
            break;
        }
      }
      $.Widget.prototype._setOption.apply(this, arguments);
    },
    _setWidth: function(width) {
      this.uiChatboxTitlebar.width(width + "px");
      this.uiChatboxLog.width(width + "px");
      //this.uiChatboxInputBox.css("maxWidth", width + "px");
      // padding:2, boarder:2, margin:5
      // this.uiChatboxInputBox.css("width", (width - 18) + "px");
    },
    _position: function(offset) {
      this.uiChatbox.css("right", offset);
    }
  });
}

export {init};
export default init;
/* vim: set ts=2 sw=2 ss=2 et :  */



// WEBPACK FOOTER //
// ./webpack/chatbot/chatbox.js